export const PaymentCard = () => {
   const handleCheckout = async (event) => {
      event.preventDefault()
   }

   return { handleCheckout }
}
